import { render, staticRenderFns } from "./ref-block.vue?vue&type=template&id=923b8e76"
import script from "./ref-block.vue?vue&type=script&lang=js"
export * from "./ref-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports